export default "__VITE_ASSET__RkxTpR2P__"